<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      </button>
    </div>
    <form [formGroup]="inputForm">
      <div class="modal-body">
        <div class="pb-4">
          <app-multiselect-dropdown [options]="racesList" [formControlName]="'races'" [maxItemsDisplay]="4" [isDropdownListFullWidth]="true"
                                    [dropdownLabel]="t('app.common.race')"/>
        </div>
        <app-textarea formControlName="chipNumbers" rows="7" label="race.management.competitors.assign.chip.numbers.input"/>
        <div class="pt-4">
          <input type="checkbox" class="form-check-input border-2 me-2" id="replaceExisting" formControlName="replaceExisting"/>
          <label class="form-check-label" for="replaceExisting">{{ t("race.management.competitors.assign.chip.numbers.replaceExisting") }}</label>
        </div>
      </div>
    </form>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()" [label]="confirmButtonTitle ?? t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"
                    [isDisabled]="!inputForm.valid || !inputForm.touched"></app-button>
      </div>
    </div>
  </div>
</ng-container>
